import { render } from "./UpdateService.vue?vue&type=template&id=61a014cc"
import script from "./UpdateService.vue?vue&type=script&lang=js"
export * from "./UpdateService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__